import * as fragments from '../../lib/fragments';

export const replaceCartCache = (key) => (cache, res) => {
  const newCart = res?.data?.[key];

  cache.modify({
    fields: {
      cart(existingCart = null) {
        // No existing cart → just write it
        if (!existingCart) {
          return newCart;
        }

        // Preserve references by merging fragment-shaped data
        const existingFragment = cache.readFragment({
          id: cache.identify(existingCart),
          fragment: fragments.CART_FIELDS_FRAGMENT,
        });

        return {
          ...existingFragment,
          ...existingCart,
          ...newCart,
        };
      },
    },
  });
};
